/**
 * Utilities for detecting React hydration issues and Chrome automatic translation.
 *
 * - `isHydrationError` checks if an error message matches known React hydration
 *   mismatch patterns and internal error codes.
 */

const REACT_HYDRATION_ERROR_CODES = {
  HYDRATION_TEXT_MISMATCH: '418',
  HYDRATION_ATTRIBUTE_MISMATCH: '423',
  HYDRATION_NODE_MISMATCH: '425',
  HYDRATION_INVALID_MARKER: '345',
} as const;

const HYDRATION_ERROR_KEYWORDS = [
  'Hydration',
  'hydrating',
  'did not match',
  'Text content does not match',
  'switch to client rendering',
  ...Object.values(REACT_HYDRATION_ERROR_CODES),
];

function isHydrationError(error: unknown): boolean {
  const errorMessage = error instanceof Error ? error.message : String(error);
  return HYDRATION_ERROR_KEYWORDS.some((keyword) =>
    errorMessage.includes(keyword),
  );
}

export { isHydrationError };
